import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        siteId: 6,
        cateList: [],   // 分类
        activeId: -1,   // 当前激活分类
        activeSubCate:undefined,
        activeIndex: -1,   // 当前激活分类下级分类
        siteInfo: {},   // 站点信息
        activeArticleId: -1,
        meta: null,
        tradeTypeList: [{
            id: 1,
            name: '工程分包'
        }, {
            id: 2,
            name: '工程采购'
        }, {
            id: 3,
            name: '其他交易'
        }, {
            id: 4,
            name: '自主交易'
        }, {
            id: 5,
            name: '经营管理'
        }, {
            id: 6,
            name: '供方管理'
        }]
    },
    getters: {
        siteId: state => state.siteId,
        cateList: state => state.cateList,
        activeId: state => state.activeId,
        activeIndex: state => state.activeIndex,
        siteInfo: state => state.siteInfo,
        activeArticleId: state => state.activeArticleId,
        meta: state => state.meta,
        tradeTypeList: state => state.tradeTypeList,
    },
    mutations: {
        SET_CETELIST(state, payload) {
            state.cateList = payload
        },
        SET_SITEINFO(state, payload) {
            state.siteInfo = payload
        },
        SET_ACTIVEID(state, payload) {
            state.activeId = payload.toString()
        },
        SET_ACTIVEIDDEX(state, payload) {
            state.activeIndex = payload
        },
        SET_ACTIVE_SUB_CATE(state,subCate) {
            console.log('subCate',subCate);
            state.activeSubCate = subCate
        },
        SET_ACTIVEARTIVLEID(state, payload) {
            state.activeArticleId =  payload
        },
        SET_META(state, payload) {
            state.meta = payload
        }
    },
    actions: {},
    modules: {}
})
